import { BlockArrayModels } from '../types'

export const isSchedules = (model: string) => {
    return model === BlockArrayModels.SCHEDULE_RANGE
}